<template>
    <OpportunityPageDetailTopLayout :minified="minified">
        <template #image>
            <CThumbnailImage
                :alt="`Dobrovoľnícky projekt ${project.title}`"
                class="rounded-md text-gray-750 dark:text-txt-headings"
                :src="project.image ? project.image : org?.image"
                type="project"
            />
        </template>
        <template #highlights>
            <!-- The page's h1; the minified preview is embedded in other pages, so it gets an h2. -->
            <CHeading class="mb-4" :tag="minified ? 'h2' : 'h1'">
                {{ project.title }}
            </CHeading>

            <LayoutTopOrgProfileLink v-if="org && project?.title !== org.title" :org="org" show-img-on-desktop />

            <IconTextRow v-if="org?.type" icon="organization">
                {{ organizationType }}
            </IconTextRow>

            <template v-if="hasTopics">
                <CSearchTags
                    class="mt-3 sm:mt-8"
                    query-search-param="topics"
                    search-route-name="dobrovolnictvo-dobrovolnicke-projekty"
                    :tags="project.topics"
                />
            </template>
        </template>

        <template #bottom>
            <ProjectParameters :minified="minified" :project="project" />
        </template>
    </OpportunityPageDetailTopLayout>
</template>

<script setup lang="ts">
import { orgTypes, valueLookup } from '#shared/types/dictionary'
import type { Org } from '#shared/types/Org'
import type { Project } from '#shared/types/Project'

const props = defineProps<{
    project: Project
    /** The full org, or the snapshot embedded in the project (`orgMeta`) while it loads. */
    org?: Pick<Org, 'id' | 'title' | 'image' | 'type' | 'slug'>
    minified?: boolean
}>()

const organizationType = computed((): string => {
    return props.org?.type ? valueLookup(props.org.type, orgTypes) || '' : ''
})

const hasTopics = computed((): boolean => {
    return Boolean(props.project.topics && props.project.topics.length > 0)
})
</script>